module.exports = {
	"articleTitle1": "Increase in rent forces Amer's deli to downsize ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Amer's Deli",
	"articleLink1": "https://www.michigandaily.com/section/news/amers-under-construction",
	"articleLink2": "https://www.michigandaily.com/article/amers-union-close",
	"articleSnippet1": "Jan 14, 2016 ... Amer's, a Mediterranean deli located on State Street, is currently under \nconstruction, and though the store owner assures students the deli's ...",
	"articleSnippet2": "Apr 30, 2013 ... After a failed campaign and much speculation, the Amer's Mediterranean Deli in \nthe Michigan Union will close its doors Saturday, May 4th.",
	"foodRecommendations": [
		{
			"text": "This place is very delicious. They have really good sandwiches.",
			"person": "Charlie Ruiz"
		}
	],
	"articleTitle2": "Amer's in the Union to close",
	"address": "611 Church St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.274442,
		"lng": -83.73428
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/amers.json
// module id = 809
// module chunks = 0